import { HttpErrorResponse } from '@angular/common/http';

interface AccountErrorBody {
	message?: string;
}

export function extractMessage(error: HttpErrorResponse): string {
	// Angular parses the JSON body automatically; the payload shape is always { message: string }.
	// If the Content-Type is absent or non-JSON the body arrives as a raw string — parse it defensively.
	let body = error.error as AccountErrorBody | string | null;
	if (typeof body === 'string') {
		try {
			body = JSON.parse(body) as AccountErrorBody;
		} catch {
			// not valid JSON — treat the string itself as the message
			return body as string;
		}
	}
	if (typeof (body as AccountErrorBody)?.message === 'string') {
		return (body as AccountErrorBody).message as string;
	}

	return error.message ?? '';
}

/**
 * Returns the Account-specific redirect path when a 403 response carries a known
 * ShureCloud error message, or undefined when no redirect is warranted.
 */
export function getAccountRedirectPath(error: unknown): string | undefined {
	if (!(error instanceof HttpErrorResponse) || error.status !== 403) {
		return undefined;
	}

	const message = extractMessage(error).toLowerCase();
	if (message.includes('shurecloud - account pending')) {
		return '/account-pending';
	}
	if (message.includes('shurecloud - account forbidden')) {
		return '/account-unavailable';
	}

	return undefined;
}
